import {
  workApprovalProxy,
  workApprovalProxyBody,
  workConfigProxy,
} from './index';

import applCode from '@/const/applCodeConstants';

// workApprovalProxy : proxy/work/approval/
// workApprovalProxyBody : proxyBody/work/approval/

// ======================= VACATION =======================
// 잔여연차 조회
function getRestCnt(params) {
  return workApprovalProxy.get('vacation/det/restcnt', {
    params,
  });
}

// 전체일수, 휴일일수 조회
function getHoliCnt(params) {
  return workApprovalProxy.get('vacation/det/holicnt', {
    params,
  });
}

// 근태 - 재직상태 및 신청대상자 체크
function checkVacationDet(params) {
  return workApprovalProxy.get('vacation/det/check', {
    params,
  });
}

// 근태 - 신청서 저장
function postVacationDet(params) {
  return workApprovalProxyBody.post('vacation/det/save', params);
}

// 근태 - 신청서 조회
function getVacationMap(params) {
  return workApprovalProxy.get('vacation/det/map', { params });
}

// 휴일근무 조회
function getHolWork(params) {
  return workApprovalProxy.get('vacation/det/holwork', { params });
}

// 적용시간 계산 조회
function getHour(params) {
  return workApprovalProxy.get('vacation/det/hour', { params });
}

// ======================= OTWORK =======================

// 휴일근무 보상구분 조회
function getOtWorkSysInfo() {
  return workApprovalProxy.get('otwork/det/sys/info');
}

// 연장근무 재직상태 조회
// 필수: ssnEnterCd, workYmd, workYmd, searchApplSabun
function getOtWorkStatus(params) {
  return workApprovalProxy.get('otwork/det/status', { params });
}

// 연장근무 신청시간 조회
function getOtWorkHour(params) {
  return workApprovalProxy.get('otwork/det/hour', { params });
}

// 연장근무 - 대체휴가 데이터 확인
function checkOtWorkAlter(params) {
  return workApprovalProxy.get('otwork/det/alter/check', { params });
}

// 연장근무 24시간 스케줄 조회
function getOtWorkTimeList(params) {
  return workApprovalProxy.get('otwork/det/time/list', { params });
}

// 연장근무 - 재직상태 및 신청대상자 체크
// 필수: ssnEnterCd, searchApplSabun, searchApplSeq, workYmd, requestHour
function checkOtWorkDet(params) {
  return workApprovalProxy.get('otwork/det/check', {
    params,
  });
}

// 연장근무 - 신청서 저장
function postOtWorkDet(params) {
  return workApprovalProxyBody.post('otwork/det/save', params);
}

// 연장근무 - 신청서 조회
function getOtWorkMap(params) {
  return workApprovalProxy.get('otwork/det/list', { params });
}

// ======================= SCHEDULE =======================

// 근무유형 근무시간 조회
// 필수: ssnEnterCd, searchWorkTypeCd
function getWorkOrgTimeList(params) {
  return workConfigProxy.get('/workorg/time/list', { params });
}

// 개인근무스케쥴 스케쥴 조회
// 필수: ssnEnterCd, searchApplSabun, stdYmd
function getScheduleStatus(params) {
  return workApprovalProxy.get('schedule/det/status', { params });
}

// 개인근무스케쥴 - 신청체크
// 필수: ssnEnterCd, searchApplSabun, sdate, edate, searchApplSeq
function checkScheduleDet(params) {
  return workApprovalProxy.get('schedule/det/check', {
    params,
  });
}

// 개인근무스케쥴 - 신청서 저장
function postScheduleDet(params) {
  return workApprovalProxyBody.post('schedule/det/one/save', params);
}

// 개인근무스케쥴 - 신청서 조회
function getScheduleMap(params) {
  return workApprovalProxy.get('schedule/det/map', { params });
}

// 개인근무스케쥴 - 스케줄 변경일 정보 조회
// 필수: ssnEnterCd, searchApplSabun, sdate, edate
function getScheduleTimeOne(params) {
  return workApprovalProxy.get('schedule/det/time/one', { params });
}

// ======================= REWARD =======================

// 보상휴가 - 전체일수, 휴일일수 조회
function getRewardHoliCnt(params) {
  return workApprovalProxy.get('reward/det/holicnt', {
    params,
  });
}

// 보상휴가신청 보상조회
function getRewardList(params) {
  return workApprovalProxy.get('/reward/det/list', { params });
}

// 보상휴가 - 재직상태 및 신청대상자 체크
function checkRewardDet(params) {
  return workApprovalProxy.get('reward/det/check', {
    params,
  });
}

// 보상휴가 - 신청서 저장
function postRewardDet(params) {
  return workApprovalProxyBody.post('reward/det/save', params);
}

// 보상휴가 - 신청서 조회
function getRewardMap(params) {
  return workApprovalProxy.get('reward/det/map', { params });
}

// ======================= ATTEND =======================

// 출퇴근변경신청 - 스케줄조회
// 필수: ssnEnterCd, searchApplSabun, workYmd
function getAttendStatus(params) {
  return workApprovalProxy.get('attend/det/status', { params });
}

// 출퇴근변경신청 - 재직상태 및 신청대상자 체크
function checkAttendDet(params) {
  return workApprovalProxy.get('attend/det/check', {
    params,
  });
}

// 출퇴근변경신청 - 신청서 저장
function postAttendDet(params) {
  return workApprovalProxyBody.post('attend/det/save', params);
}

// 출퇴근변경신청 - 신청서 조회
function getAttendMap(params) {
  return workApprovalProxy.get('attend/det/list', { params });
}

// ======================= CANCEL =========================

// 근태취소신청 - 신청 확인
function checkCancelVacation(params) {
  return workApprovalProxy.get('vacation/upd/det/check', { params });
}
// 근태취소신청 - 신청서 저장
function postCancelVacation(params) {
  return workApprovalProxyBody.post('vacation/upd/det/save', params);
}
// 근태취소신청 - 신청서 조회
function getCancelVacationMap(params) {
  return workApprovalProxy.get('vacation/upd/det/map', { params });
}
// 근태취소신청 - 신청서 회수
function deleteCancelVacation(params) {
  return workApprovalProxyBody.post('vacation/app/save2', params);
}

// 보상휴가취소신청 - 신청 확인
function checkCancelReward(params) {
  return workApprovalProxy.get('reward/upd/det/check', { params });
}
// 보상휴가취소신청 - 신청서 저장
function postCancelReward(params) {
  return workApprovalProxyBody.post('reward/upd/det/save', params);
}
// 보상휴가취소신청 - 신청서 조회
function getCancelRewardMap(params) {
  return workApprovalProxy.get('reward/upd/det/map', { params });
}

// 신청서 회수 (공통)
function deleteApplication(applCd, params) {
  let url = '';
  if (applCd === applCode.Vacation) {
    url = 'vacation/app/save';
  } else if (applCd === applCode.OtWork) {
    url = 'otwork/app/save';
  } else if (applCd === applCode.Schedule) {
    url = 'schedule/app/save';
  } else if (applCd === applCode.Reward) {
    url = 'reward/app/save';
  } else if (applCd === applCode.Attend) {
    url = 'attend/app/save';
  } /*else if (applCd === applCode.CancelVacation) {
    url = 'vacation/app/save2';
  }*/ else if (applCd === applCode.CancelReward) {
    url = 'reward/app/save2';
  } else if (applCd === applCode.Vaccination) {
    url = 'vaccination/det/delete';
  } else if (applCd === applCode.EdusApp) {
    url = 'edusapp/det/delete';
  } else if (
    applCd === applCode.LeaAbsParental ||
    applCd === applCode.LeaAbsFamily ||
    applCd === applCode.LeaAbsInfertility ||
    applCd === applCode.LeaAbsApplication ||
    applCd === applCode.LeaAbsSick ||
    applCd === applCode.LeaAbsCasualty ||
    applCd === applCode.LeaAbsNew ||
    applCd === applCode.LeaAbsExtension ||
    applCd === applCode.LeaAbsAdd ||
    applCd === applCode.eaAbsExtension
  ) {
    url = 'leaabs/det/delete';
  } else if (applCd === applCode.Vacations) {
    url = 'vacation/delete';
  } else if (applCd === applCode.VacationsCancel) {
    url = 'vacation/cancel/delete';
  } else if (applCd === applCode.WorkScheduleTime1) {
    url = 'work/schedule/time/delete';
  } else if (applCd === applCode.HolReplaceApp) {
    url = 'hol/replace/det/delete';
  } else if (applCd === applCode.HolReplaceBoxView) {
    url = 'hol/replace/det/cancel/delete';
  } else if (
    applCd === applCode.ReCertTenureAppView ||
    applCd === applCode.ReCertTenureEngAppView ||
    applCd === applCode.ReCertTenureTax1AppView ||
    applCd === applCode.ReCertTenureTax2AppView ||
    applCd === applCode.ReCertLeaveAppView ||
    applCd === applCode.ReCertGabTaxView
  ) {
    url = 're/cert/delete';
  }

  params.applCd = applCd;
  return workApprovalProxyBody.post(url, params);
}

export {
  // 근태
  getRestCnt,
  getHoliCnt,
  checkVacationDet,
  postVacationDet,
  getVacationMap,
  getHolWork,
  getHour,
  // 연장근무
  getOtWorkSysInfo,
  getOtWorkStatus,
  getOtWorkHour,
  checkOtWorkAlter,
  getOtWorkTimeList,
  checkOtWorkDet,
  postOtWorkDet,
  getOtWorkMap,
  // 근무스케줄
  getWorkOrgTimeList,
  getScheduleStatus,
  checkScheduleDet,
  postScheduleDet,
  getScheduleMap,
  getScheduleTimeOne,
  // 보상휴가
  getRewardHoliCnt,
  getRewardList,
  checkRewardDet,
  postRewardDet,
  getRewardMap,
  // 출퇴근변경신청
  getAttendStatus,
  checkAttendDet,
  postAttendDet,
  getAttendMap,
  // 취소신청
  checkCancelVacation,
  postCancelVacation,
  getCancelVacationMap,
  deleteCancelVacation,
  checkCancelReward,
  postCancelReward,
  getCancelRewardMap,
  deleteApplication,
};
